import { ProductsResult } from '../shop';

export function filterByExactSku(search: any, searchQuery: string): any {
  const edges = search?.edges ?? [];

  const matched = edges.find((edge: any) =>
    edge?.node?.variants?.edges?.some((v: any) => v?.node?.sku?.toLowerCase() === searchQuery.toLowerCase())
  );

  if (matched) {
    const matchingVariants = matched.node.variants.edges.filter((v: any) => v?.node?.sku?.toLowerCase() === searchQuery.toLowerCase());

    return {
      edges: [
        {
          cursor: 'sku-match',
          node: {
            ...matched.node,
            variants: {
              ...matched.node.variants,
              edges: matchingVariants,
            },
          },
        },
      ],
      pageInfo: {
        hasNextPage: false,
        hasPreviousPage: false,
      },
    };
  }

  return search;
}
